
import { defineComponent, ref, inject } from 'vue'
import type { FormInstance } from "element-plus";
import { ElNotification, ElScrollbar } from 'element-plus'
import formService from "@/core/services/FormService"
import { useI18n } from "vue-i18n/index";
import { errManager } from "@/core/config/Tools";

//formularios
import Form1 from "./FormsFisu/GeneralEntryForm.vue"
import Form2 from "./FormsFisu/QuantitativeForm.vue"
import CountDown from "@/components/widgets/mixed/dsCounter.vue"

export default defineComponent({
    props: {
        itemForm: {
            type: null,
            required: true,
            default: 0
        },
        idevent: {
            type: null,
            required: true,
            default: 0
        },
    },
    components: { Form1, Form2, CountDown },
    emits: ['modalClosed'],
    setup(props, { emit }) {
        const { t } = useI18n();
        const altura = screen.height - 30;
        const dialogForm = inject<any>("dialogForm")
        const loading = ref(false)
        const idForm = ref(0)
        const childComponentRef = ref<any>(null)
        const isFormLoaded = ref(false);
        const scrollbarRef = ref<InstanceType<typeof ElScrollbar> | null>(null);
        const formExpired = ref<Boolean>(false)

        const onFormLoaded = () => {
            isFormLoaded.value = true;
        };

        const onOpened = () => {
            idForm.value = props.itemForm?.idform
        }
        const onClosed = () => {
            idForm.value = 0;
            isFormLoaded.value = false
            formExpired.value = false
            emit('modalClosed')
        }

        const resetForm = (formEl: FormInstance | undefined) => {
            if (!formEl) return;
            formEl.resetFields();
        };

        const save = async (method) => {
            loading.value = true
            childComponentRef.value.formQ.save = method;
            await formService.saveForm(`${childComponentRef.value.formQ.idform}/save`, childComponentRef.value.formQ)
                .then((res) => {
                    loading.value = false
                    if (res.data.status == 'success')
                        dialogForm.value = false
                    ElNotification({
                        title: res.data.title,
                        message: res.data.message,
                        type: res.data.status,
                    })
                }).catch(({ response }) => {
                    loading.value = false
                    errManager(response)
                })
        }

        const saveAsDraf = () => {
            save(0)
        }

        const saveAndSend = async () => {
            if (childComponentRef.value) {
                await childComponentRef.value.formQRef.validate((valid: boolean) => {
                    if (valid)
                        save(1)
                    else {
                        ElNotification({
                            title: 'Campos vacíos',
                            message: 'Complete los campos que son obligatorios',
                            type: 'error',
                            customClass: 'bg-warning border-2 border-warning text-white',
                        })
                        if (scrollbarRef)
                            scrollbarRef.value?.scrollTo({ top: 120, behavior: 'smooth' });
                    }
                })

            }
        }

        const changeStatus = (data: any) => {
            formExpired.value = data
        }

        /*const convertFecha = async(){

        }
        */



        return {
            t,
            altura,
            dialogForm,
            idForm,
            loading,
            childComponentRef,
            isFormLoaded,
            scrollbarRef,
            formExpired,

            //methods
            onOpened,
            onClosed,
            saveAsDraf,
            saveAndSend,
            onFormLoaded,
            changeStatus
        }

    },
})
